export default __webpack_public_path__ + "static/media/ic_create.3f28df8e.svg";